package com.parmartechnologies.storage.table.inventory

import com.parmartechnologies.storage.constant.KeyConstant.Companion.id
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable
import com.parmartechnologies.core.navigation.NavigationParam

class InventoryDatabaseTable : DatabaseTable() {
    fun insert(item: Inventory?) {
        item?.let {
            DatabaseCollection().insert(item, Inventory.serializer())
        }
    }

    fun insert(items: List<Inventory>?, callback: () -> Unit) {
        items?.let {
            DatabaseCollection().insertAll(items, Inventory.serializer())
        }
        callback()
    }

    fun update(item: Inventory?, callback: () -> Unit) {
        item?.let {
            DatabaseCollection().insert(item, Inventory.serializer())
        }
        callback()
    }

    fun retrieve(id: String, callback: (List<Inventory>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id, Inventory.serializer()){
            callback(it)
        }
    }

    fun retrieveAll(id: String,callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",id))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun search(query: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("business_id",id),Pair("product_id",param!!.product._id))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun findByColorId(colorId: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",param!!.product._id),Pair("color_id",colorId))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun findBySizeId(sizeId: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",param!!.product._id),Pair("size_id",sizeId))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun findByUOMId(uomId: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",param!!.product._id),Pair("uom_id",uomId))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun findByColorIdAndSizeId(colorId: String, sizeId: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",param!!.product._id),Pair("size_id",sizeId),Pair("color_id",colorId))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun findByColorIdAndUOMId(colorId: String, uomId: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",param!!.product._id),Pair("uom_id",uomId),Pair("color_id",colorId))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun findBySizeIdAndUOMId(sizeId: String, uomId: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",param!!.product._id),Pair("uom_id",uomId),Pair("size_id",sizeId))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }

    fun findByColorIdAndSizeIdAndUOMId(colorId: String, sizeId: String, uomId: String, param: NavigationParam?, callback: (List<Inventory>) -> Unit) {
        val andQuery : Map<String,Any> = mapOf(Pair("product_id",param!!.product._id),Pair("uom_id",uomId),Pair("size_id",sizeId))
        DatabaseCollection().findAll(andQuery, Inventory.serializer()){
            callback(it)
        }
    }


    fun LastSyncDate(id: String, callback: (String?) -> Unit) {
//        val table = AppDatabase.shared().database?.inventoryTableQueries
//        scope.launch {
//            val dateFromDb = table?.LastSyncDate(id)?.awaitAsOneOrNull()
//            callback(dateFromDb?.UpdatedAt)
//        }
    }

    fun LastSyncDate(param: NavigationParam?, callback: (String?) -> Unit) {
        callback("")
//        val table = AppDatabase.shared().database?.inventoryTableQueries
//        if(param?.business != null && param.product != null){
//            scope.launch {
//                val dateFromDb = table?.LastSyncDateForProduct(param.business!!._id,param.product!!._id)?.awaitAsOneOrNull()
//                callback(dateFromDb?.UpdatedAt)
//            }
//        }else{
//            callback(null)
//        }

    }

}